/** @jsxImportSource @emotion/react */
import { Typography } from '@quickbit/qb-design-system';
import { diff, formatters } from 'jsondiffpatch';
import 'jsondiffpatch/dist/formatters-styles/html.css';
import { useMemo } from 'react';

interface Props {
  oldString: string;
  newString: string;
  noDiffText: string;
}

export const JsonDiff = ({ oldString, newString, noDiffText }: Props) => {
  const htmlDiff = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ajson = JSON.parse(oldString);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const bjson = JSON.parse(newString);
    const d = diff(ajson, bjson);
    const formatter = formatters.html;
    formatter.hideUnchanged();
    if (d) return formatter.format(d, ajson);
    return null;
  }, [oldString, newString]);

  if (!htmlDiff) return <Typography>{noDiffText}</Typography>;
  return <div dangerouslySetInnerHTML={{ __html: htmlDiff }} />;
};
